module.exports = __webpack_public_path__ + "img/fixed_mirro.10c08ba8.svg";